import axios from "axios";
import { API_ENDPOINTS } from "../../../helpers/config";

export const CategoryService = {
  getCategories: async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL + API_ENDPOINTS.CATEGORY.GET_ALL
      );
      return response.data;
    } catch (err) {
      console.log(err);
    }
  },

  createCategory: async (data: any) => {
    try {
      const response = await axios.post(
        process.env.REACT_APP_API_URL + API_ENDPOINTS.CATEGORY.CREATE_CATEGORY,
        data
      );
      return response;
    } catch (err) {
      console.log(err);
    }
  },

  deleteCategory: async (id: string) => {
    try {
      const response = await axios.delete(
        process.env.REACT_APP_API_URL +
          API_ENDPOINTS.CATEGORY.DELETE_CATEGORY +
          id
      );
      return response;
    } catch (err) {
      console.log(err);
    }
  },
};
